const location = {
  placeId: "",
  country: "",
  state: "",
  city: "",
  postalCode: "",
  address: "",
  name: "",
  latitude: 0,
  longitude: 0,
  arrivalDate: "",
  departureDate: "",
  duration: 0,
  distance: 0,
  observation: "",
  isReturn: false,
  type: "",
};

const constants = {
  state: {
    USER: "user",
    JWT: "jwt",
    IS_LOGGED_IN: "is_logged_in",
  },
  status: {
    ERROR_MESSAGE: "error_message",
    SUCCESS_MESSAGE: "success_message",
    INFO_MESSAGE: "info_message",
    WARNING_MESSAGE: "warning_message",
  },
  UUID: "uuid",
  IS_SIDEBAR_CONTRACTED: "is_sidebar_contracted",
  location,
  googleMapsApiKey: "AIzaSyDDxdx5UwTI1itZnLKjuf2a1ZBK9LopNEI",
};

export default constants;
